import React, { FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'

import { TeamInfo } from './components/TeamInfo/TeamInfo'
import { GameInfo } from './components/GameInfo/GameInfo'
import { FooterInfo } from './components/FooterInfo/FooterInfo'

import classes from './GameCardItem.module.scss'

type GameCardItemProps = {
  item: FeedData
}

export const GameCardItem: FC<GameCardItemProps> = ({ item }) => {
  return (
    <div className={classes.Container}>
      <div className={classes.Body}>
        <TeamInfo team={item.homeTeam} />
        <GameInfo game={item} />
        <TeamInfo team={item.awayTeam} />
      </div>
      <FooterInfo game={item} />
    </div>
  )
}
